<template>
  <!-- 摄像头弹窗 -->
  <el-dialog
    class="cmp cmp-camera-popper"
    :before-close="handleClose"
    width="540px"
    title="调试摄像头"
    :close-on-click-modal="false"
    :show-close="false"
    :visible.sync="isOpenCamera"
  >
    <div class="monitorFlex">
      <div class="monitorView" ref="monitorView">
        <div :class="['bg', `${isRecordVideo ? 'faceBg' : 'monitorBg'}`]"></div>
        <video class="video" ref="video" autoplay></video>
        <canvas
          :width="takePhotoWidth"
          :height="takePhotoHeight"
          :style="{
            width: `${takePhotoWidth}px`,
            height: `${takePhotoHeight}px`,
          }"
          ref="canvas"
        ></canvas>
        <img class="facePhotoImg" v-if="facePhoto" :src="facePhoto" alt />
      </div>
      <div class="monitorContent">
        <p>
          {{ isRecordVideo ? '请选择摄像头' : '未检测到摄像头，请刷新硬件' }}
        </p>
        <div class="choiceMonitor">
          <el-select
            @change="switchCamera"
            v-model="mediaDeviceActiveDeviceId"
            placeholder="请选择"
          >
            <el-option
              v-for="(v, i) in mediaDevicesList"
              :key="i"
              :label="v.label"
              :value="v.deviceId"
            >
            </el-option>
          </el-select>
          <el-button type="text" size="medium" @click="checkCamera"
          style="text-decoration: underline;text-underline-offset: 7px;"
            >刷新硬件</el-button
          >
        </div>
        <p class="text-left text-danger">
          注：1.拍照时请正面对准摄像头，清晰地对准自己的五官，避免照片出现模糊不清的情况。2.考试过程中需要全程开启摄像头，关闭摄像头将不能参加考试。
        </p>
        <div class="btns">
          <el-button
            :disabled="!isRecordVideo"
            v-if="!facePhoto"
            @click="takePhoto"
            type="success"
            >拍照</el-button
          >
          <el-button v-if="facePhoto" @click="remake">重拍</el-button>
          <el-button v-if="facePhoto" @click="uploadImgOrJump" type="primary"
            >确定</el-button
          >
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex';
import jstools from 'jstools-common/dist/jstools.web';
import cosUtil from '@/assets/scripts/cosUtil';
import api from '@/api/index.js';
export default {
  data() {
    return {
      maintainNotice: false,
      cameraTimesDate: null, // 摄像头数据定时器
      takePhotoWidth: 0,
      takePhotoHeight: 0,
      mediaStream: null, // 摄像头数据
      isRecordVideo: false, // 是否开启摄像头
      mediaDevicesList: [], // 存放多个摄像头
      mediaDeviceActiveDeviceId: '', // 当前摄像头的id
      isOpenCamera: false, // 摄像头弹框
      facePhoto: '', // 人脸照片
      ischeatMonitor: false, // 是否开启防作弊
    };
  },
  computed: {
    ...mapState(['activityActive']),
  },
  mounted() {},
  filters: {
    formatDate(val, format) {
      return jstools.formatDate(val, format);
    },
  },
  beforeDestroy() {
    this.stopNavigator();
  },
  methods: {
    // 定时器监听摄像头
    videoLisener() {
      this.cameraTimesDate = setInterval(() => {
        if (!this.mediaStream.active) {
          this.isRecordVideo = false;
          clearInterval(this.cameraTimesDate); // 清除定时检测摄像头
        }
      }, 1000);
    },
    // 关闭摄像头
    stopNavigator() {
      if (this.mediaStream) {
        if (this.mediaStream.stop) {
          this.mediaStream.stop();
        } else {
          // Chrome 45版本以上关闭摄像头的方式
          let track = this.mediaStream.getTracks()[0];
          track.stop && track.stop();
        }
        this.isRecordVideo = false; // 关闭摄像头标识
        clearInterval(this.cameraTimesDate);
      }
    },
    handleClose(done) {
      this.stopNavigator();
      done && done();
    },
    initVideoWrapper() {
      if (this.$refs.monitorView) {
        this.takePhotoWidth = this.takePhotoHeight = Math.min(
          this.$refs.monitorView.clientWidth,
          this.$refs.monitorView.clientHeight
        );
      }
    },
    // 重新拍照
    remake() {
      this.facePhoto = '';
    },
    //  绘制图片（拍照功能）
    takePhoto: jstools.debounce(function () {
      if (!this.isRecordVideo) {
        this.$message.error('您的摄像头没有开启，无法拍照！');
        return false;
      }
      var _this = this;
      if (this.$refs.video && this.$refs.canvas) {
        let videoInfo = this.$refs.video.getBoundingClientRect();
        let canvasInfo = this.$refs.canvas.getBoundingClientRect();
        let dx = canvasInfo.x - videoInfo.x;
        let dy = canvasInfo.y - videoInfo.y;
        let flag = this.$refs.video.videoHeight / videoInfo.height;
        this.$nextTick(() => {
          let ctx = this.$refs.canvas.getContext('2d');
          ctx.clearRect(0, 0, this.takePhotoWidth, this.takePhotoHeight);
          ctx.drawImage(
            this.$refs.video,
            dx * flag,
            dy * flag,
            this.takePhotoWidth * flag,
            this.takePhotoHeight * flag,
            0,
            0,
            this.takePhotoWidth,
            this.takePhotoHeight
          );
          let photo = this.$refs.canvas.toDataURL('image/jpeg') || '';
          _this.facePhoto = photo;
        });
      }
    }),
    // 切换摄像头
    switchCamera(value) {
      if (!value) return;
      this.getCompetence(value);
    },
    // 开启摄像头
    openCameraBtn() {
      this.activityNoticeModule = false;
      this.idCheckModule = false;
      this.isOpenCamera = true;
      this.facePhoto = '';
      this.checkCamera(); // 调用摄像头
      setTimeout(() => {
        this.initVideoWrapper();
      }, 800);
    },
    checkCamera() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        // 未知则直接交给getCamera做尝试
        this.getCompetence(); // 进入页面就调用摄像头
      } else {
        this.mediaDevicesList = [];
        navigator.mediaDevices.enumerateDevices().then((deviceInfos) => {
          this.mediaDevicesList = deviceInfos.filter(
            (v) => v.kind === 'videoinput'
          );
          if (this.mediaDevicesList.length) {
            // 默认第一个摄像头
            this.mediaDeviceActiveDeviceId = (
              this.mediaDevicesList[0] || {}
            ).deviceId;
            this.getCompetence((this.mediaDevicesList[0] || {}).deviceId);
          } else {
            this.mediaDevicesList = [];
            this.isRecordVideo = false;
            this.$message.error('未检测到可用的摄像头设备，请连接设备后重试');
          }
        });
      }
    },
    // 打开摄像头
    getCompetence(deviceId) {
      let constraints = {
        video: deviceId ? { deviceId: { exact: deviceId } } : {},
        audio: false,
      };
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then(this.getCameraSuccess)
          .catch(this.getCameraError);
      } else if (navigator.webkitGetUserMedia) {
        navigator
          .webkitGetUserMedia(constraints)
          .then(this.getCameraSuccess)
          .catch(this.getCameraError);
      } else if (navigator.mozGetUserMedia) {
        navigator
          .mozGetUserMedia(constraints)
          .then(this.getCameraSuccess)
          .catch(this.getCameraError);
      } else if (navigator.msGetUserMedia) {
        navigator
          .msGetUserMedia(constraints)
          .then(this.getCameraSuccess)
          .catch(this.getCameraError);
      } else if (navigator.getUserMedia) {
        navigator
          .getUserMedia(constraints)
          .then(this.getCameraSuccess)
          .catch(this.getCameraError);
      } else {
        this.$message.error(
          '你的浏览器不支持访问用户媒体设备，请更换浏览器后重试'
        );
      }
    },
    // 调用摄像头 - 成功
    getCameraSuccess(stream) {
      this.isRecordVideo = true; // 开启摄像头标识
      this.videoLisener();
      this.mediaStream = stream;
      this.$refs['video'].srcObject = stream; // 实时拍照效果
    },
    // 调用摄像头 - 失败
    getCameraError(err) {
      console.error(err);
      if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
        this.$message.error('未检测到可用的摄像头设备，请连接设备后重试');
      } else if (
        err.name === 'NotReadableError' ||
        err.name === 'TrackStartError' ||
        err.name === 'SourceUnavailableError'
      ) {
        this.$message.error('检测到设备正被占用，请稍后重试');
      } else if (
        err.name === 'OverconstrainedError' ||
        err.name === 'ConstraintNotSatisfiedError'
      ) {
        this.$message.error('检测到设备参数无法满足功能需求');
      } else if (
        err.name === 'NotAllowedError' ||
        err.name === 'PermissionDeniedError'
      ) {
        this.$message.error('调用设备权限被拒绝');
      } else if (err.name === 'TypeError') {
        this.$message.error('设备参数要求未设置');
      } else {
        this.$message.error('访问用户媒体设备失败：', err.name, err.message);
      }
      this.isRecordVideo = false;
    },
    selectCamera() {
      // 存储当前选中摄像头id
      window.localStorage.setItem('deviceId', this.mediaDeviceActiveDeviceId);
      this.$router.push({ name: 'pretest' });
    },
    uploadImgOrJump: jstools.debounce(function () {
      // 拍照上传
      let _this = this;
      let _file = cosUtil.base64ToFile(this.facePhoto);
      cosUtil
        .upload({file: _file})
        .then((res) => {
          console.log(3333, res);
          if (res) {
            api
              .answerStudentFace({
                activityId: this.activityActive.id,
                ossId: res.fileId,
                // ossId: res.resourceKey,
                type: 1,
              })
              .then(() => {
                if (
                  this.examinationStatus === 3 ||
                  this.examinationStatus === 1
                ) {
                  this.isOpenCamera = false;
                  this.isCheckComplete = true;
                } else {
                  // 存储当前选中摄像头id
                  window.localStorage.setItem(
                    'deviceId',
                    this.mediaDeviceActiveDeviceId
                  );
                  _this.$router.push({
                    name: 'pretest',
                  });
                }
                this.stopNavigator();
              })
              .catch((error) => {
                _this.$message.error(error.msg);
              });
          }
        })
        .catch((err) => {
          this.$message.error('COS上传图片失败');
          console.log(err, 'COS上传图片失败 ==========');
        });
    }),
    jumpPretest() {
      // 跳转前测
      // 判断是否可以进入前测 前30分钟
      this.$router.push({
        name: 'pretest',
      });
    },
  },
};
</script>
<style lang="less" scoped>
.cmp-camera-popper {
  .monitorFlex {
    .monitorView {
      width: 150px;
      height: 150px;
      margin: 0 auto;
      position: relative;
      overflow: hidden;
      .facePhotoImg {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 100;
      }
      .bg {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 99;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      .faceBg {
        background: url('../assets/images/public/bg_face.png') no-repeat center;
        background-size: contain;
      }
      .monitorBg {
        background: url('../assets/images/public/bg_monitor.png') no-repeat
          center #fff;
        background-size: contain;
      }
      canvas {
        width: 100%;
        height: 100%;
      }
      .video {
        width: auto;
        height: 100%;
        object-fit: cover;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .monitorContent {
      padding: 0px 15px;
      h3 {
        padding: 10px 0;
      }
      .choiceMonitor {
        margin-bottom: 20px;
        button {
          margin-left: 20px;
          i {
            vertical-align: middle;
            margin-left: 5px;
          }
        }
      }
      .btns {
        padding-bottom: 15px;
        display: flex;
        text-align: center;
        justify-content: center;
        button {
          width: 200px;
          height: 40px;
          margin: 0px 10px;
        }
      }
    }
  }
}
</style>
